
<template>
  <AddDecaissement />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumbs from "@/layout/BreadCrumbs.vue";
import AddDecaissement from "@/components/GesCom/Operations/AddDecaissement.vue";

export default defineComponent({
  name: "AddDecaissementPage",
  components: {
    BreadCrumbs,
    AddDecaissement,
  },
});
</script>

